export const TRACEABILITY: string = 'tracabilite';
export const ANALYTICS: string = 'analytic';
export const ML: string = 'machine-learning';
export const LABELIZE: string = 'labelisation';
export const ADAPTCUT: string = 'adaptcut-connector';
export const TOOL_RECOMMENDER: string = 'tool-recommender';

export const USER_MODULES = [TRACEABILITY, ANALYTICS, ML, TOOL_RECOMMENDER] as const;
export type UserModules = (typeof USER_MODULES)[number];
export type UserModulesList = UserModules[];

// UI-gated modules exposed by this frontend build.
export const ENABLED_MODULES: string[] = [TRACEABILITY, ANALYTICS, ML, TOOL_RECOMMENDER];

// Canonical backend module keys — mirrors orchestrator common/constants ALL_MODULES_KEYS.
export const ALL_MODULE_KEYS: string[] = [
  TRACEABILITY, ANALYTICS, ADAPTCUT, ML, LABELIZE, TOOL_RECOMMENDER,
];
